import React from 'react';
import { eAccessControlUserType } from '../../enums/eAccessControlUserType';
import { clientUrls } from '../../rest/ClientUrlFactory';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { Anchor, Banner, Flex, Text, TextButton } from '@zillow/constellation';
import { getDefaultHomeLinkForUserType } from '../../../components/accessControl/getDefaultHomeLinkForUserType';

const list = [
  { permission: ePermissions.AdminRead, userType: eAccessControlUserType.Admin },
  { permission: ePermissions.ReadClientPortal, userType: eAccessControlUserType.Client },
  { permission: ePermissions.ReadVendorPortal, userType: eAccessControlUserType.Vendor },
];

export const PageNotFound: React.FC = () => {
  const currentUrl = window.location.href;

  const loginLink = (userType: eAccessControlUserType) =>
    `${clientUrls.urlFor.spaLogin(userType)}?redirect_back_after_sign_in=${encodeURIComponent(currentUrl)}`;

  return (
    <>
      <Banner appearance={'error'} body={'This page does not exist, or you do not have permission to view it.'} />
      <Flex display={'flex'} flexDirection={'column'} padding={'md'} gap={'md'}>
        <Text>You may try logging in</Text>
        <Flex display={'flex'} flexDirection={'row'} gap={'lg'} paddingX={'sm'}>
          {list.map(({ userType }) => (
            <TextButton key={userType} as={'a'} href={loginLink(userType)}>
              {userType}
            </TextButton>
          ))}
        </Flex>
        {list.map(({ permission, userType }) => (
          <AccessControlCheck key={userType} allowedPermissions={[permission]}>
            <Text>
              Or you can go back to your <Anchor href={getDefaultHomeLinkForUserType(userType)}>homepage</Anchor>.
            </Text>
          </AccessControlCheck>
        ))}
      </Flex>
    </>
  );
};
